import {Component, Inject, OnInit} from '@angular/core';
import {ActivationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';
import {BreadcrumbService} from '../../../service/breadcrumb.service';
import {AppComponent} from '../../../app.component';
import {DOCUMENT} from "@angular/common";

@Component({
    template: ''
})
export class BaseComponent implements OnInit {

    public isBrowser: boolean = false;

    constructor(@Inject(DOCUMENT) public document: Document,
                protected router: Router,
                protected breadcrumbService: BreadcrumbService) {
        AppComponent.isBrowser.subscribe((isBrowser: boolean) => this.isBrowser = isBrowser);
    }

    ngOnInit(): void {
        // Handle initial route
        this.breadcrumbService.generateBreadcrumbs(this.router.routerState.snapshot.root);

        // Subscribe to subsequent navigation events
        this.router.events.pipe(
            filter(event => event instanceof ActivationEnd)
        ).subscribe((event: any): void => {
            this.breadcrumbService.generateBreadcrumbs(event.snapshot);
        });
    }

    setCanonicalURL(url: string = 'https://www.solarcentral.co.za/'): void {
        let link: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');

        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }

        link.setAttribute('href', url);
    }
}